import {
  SET_PSMS_FILTERS,
  UPDATE_PSMS_FILTER,
  RESET_PSMS_FILTER,
  PSMS_FILTERS_CHANGED,
  SET_PSMS_BASE_PAYLOAD,
  PSMS_EXTENDED_TIN_DETAIL_REQUEST,
  PSMS_EXTENDED_TIN_DETAIL_SUCCESS,
  FETCH_PSMS_INDICATOR_REQUEST,
  GET_PSMS_INDICATOR_SUCCESS,
  GET_PSMS_INDICATOR_FAILURE,
} from '../actionTypes';
 
/**
 * Set all PSMS filters at once
 * @param filters - Object containing all filter values
 */
export const setPSMSFilters = (filters: any) => ({
  type: SET_PSMS_FILTERS,
  payload: filters,
});
 
/**
 * Update a single PSMS filter
 * @param filterId - The ID of the filter to update (e.g., 'timeperiod', 'lob', 'region', 'state', 'market')
 * @param value - The new value for the filter
 */
export const updatePSMSFilter = (filterId: string, value: any) => ({
  type: UPDATE_PSMS_FILTER,
  payload: { filterId, value },
});
 
/**
 * Reset a single PSMS filter to its initial value
 * @param filterId - The ID of the filter to reset
 */
export const resetPSMSFilter = (filterId: string) => ({
  type: RESET_PSMS_FILTER,
  payload: { filterId },
});
 
/**
 * Trigger for saga - dispatched when filters change and API calls need to be made
 * Note: Currently no API logic, but this action is here for future saga implementation
 * @param filters - The updated filters object
 */
export const psmsFiltersChanged = (filters: any) => ({
  type: PSMS_FILTERS_CHANGED,
  payload: filters,
});
 
/**
 * Store base payload from saga (for future use)
 * @param payload - The base payload object
 */
export const setPSMSBasePayload = (payload: any) => ({
  type: SET_PSMS_BASE_PAYLOAD,
  payload,
});

export const setExtendedTinDetailRequest = (payload: any) => ({
  type: PSMS_EXTENDED_TIN_DETAIL_REQUEST,
  payload,
});

export const setExtendedTinDetailRequestSuccess = (payload: any) => ({
  type: PSMS_EXTENDED_TIN_DETAIL_SUCCESS,
  payload,
});

// PSMS indicator action creators
export const fetchPsmsIndicatorRequest = (payload: any) => ({
  type: FETCH_PSMS_INDICATOR_REQUEST,
  payload,
});

export const fetchPsmsIndicatorSuccess = (payload: any) => ({
  type: GET_PSMS_INDICATOR_SUCCESS,
  payload,
});

export const fetchPsmsIndicatorError = (payload: any) => ({
  type: GET_PSMS_INDICATOR_FAILURE,
  payload,
});